import * as Sentry from '@sentry/react';
import { NbFallback } from 'noddi-ui-web';
import { PropsWithChildren } from 'react';
import { log } from './utils';

export function NoddiErrorBoundary({ children }: PropsWithChildren) {
  return (
    <Sentry.ErrorBoundary
      fallback={<NbFallback />}
      onError={(err, componentStack) => {
        log({
          value: componentStack,
          severity: 'error',
          cause: err
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
